import { render, staticRenderFns } from "./LegacyUnifiedSearch.vue?vue&type=template&id=68456fd3&scoped=true"
import script from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
export * from "./LegacyUnifiedSearch.vue?vue&type=script&lang=js"
import style0 from "./LegacyUnifiedSearch.vue?vue&type=style&index=0&id=68456fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68456fd3",
  null
  
)

export default component.exports